// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__bOhx1","header":"PatientQuestionnaire_header__1xwnk","info":"PatientQuestionnaire_info__2ioI7"};